import './legal.styl';

import React from 'react';
import {FormattedMessage} from 'react-intl';

const Legal = () =>
  <div className="legal">
    <FormattedMessage id="footer.disclaimer" />
  </div>;


export default Legal;



// WEBPACK FOOTER //
// ./src/client/pages/legal/Legal.js